module.exports = __webpack_public_path__ + "c4b3bc4bfe70a5b998a88091c793bf77.pdf";